import { ref } from 'vue';

const open = ref(false);

export function useSidebar() {
  return open;
}
